import { lazy, Suspense } from "react";
import { NotFoundPage } from "../../app/NotFoundPage";
import { presentText } from "../../shared/i18n/presentText";
import { useSession } from "../../shared/session/session-context";

const ControllerPage = lazy(async () => ({ default: (await import("./ControllerPage")).ControllerPage }));
const AudiencePage = lazy(async () => ({ default: (await import("./AudiencePage")).AudiencePage }));

/**
 * The two chromeless Presentations routes (PRESENT-SPEC-20261028 §7.2, §7.3): no app shell, still behind sign-in (SessionGate sends
 * a signed-out visitor to sign-in and back). `Features__Presentations` off: the controller is "Page not found" and the audience
 * screen says Presentations are not available (§11 PRS-01). Partners never present or watch.
 */
export function PresentRoute({ screen }: { screen: "controller" | "audience" }) {
  const session = useSession();
  if (!session.flag("Presentations") || session.isPartner) {
    if (screen === "controller") return <NotFoundPage />;
    return (
      <main className="gf-login" id="main">
        <div className="gf-login-card stack">
          <h1>{presentText("audienceTitle")}</h1>
          <p>{presentText("notAvailable")}</p>
        </div>
      </main>
    );
  }
  return (
    <Suspense
      fallback={
        <div className="gf-loading" role="status">
          {presentText("loading")}
        </div>
      }
    >
      {screen === "controller" ? <ControllerPage /> : <AudiencePage />}
    </Suspense>
  );
}
